"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalHost = void 0;
const isLocalHost = () => {
    return (/(localhost|127\.0\.0\.1|10\..*|172\..*|192\.168\..*)/g.test(window.location.hostname) || window.location.hostname.includes("ngrok.io"));
};
exports.isLocalHost = isLocalHost;
//# sourceMappingURL=config.js.map